var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_locked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_locked",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    fill: "#C60000",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy",
    transform: "translate(6.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0198,0 L2.9798,0 C1.8858,0 0.9998,0.886 0.9998,1.98 L0.9998,3 L1.9998,3 L1.9998,1.99 C1.9998,1.443 2.4428,1 2.9898,1 L3.0098,1 C3.5568,1 3.9998,1.443 3.9998,1.99 L3.9998,3 L4.9998,3 L4.9998,1.98 C4.9998,0.886 4.1138,0 3.0198,0",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 0.9998,
    y: 3,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 3.9998,
    y: 3,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,4 L2,4 L1,4 C0.448,4 0,4.448 0,5 L0,7.00104344 C0,7.55275191 0.45097518,8 0.990777969,8 L5.00922203,8 C5.55641359,8 6,7.55733967 6,7.00104344 L6,5 C6,4.448 5.552,4 5,4 L4,4 Z",
    id: "Fill-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked);
export default __webpack_public_path__ + "static/media/icon_locked.ed9d5fdc5faf934be890f8a31cc900b3.svg";
export { ForwardRef as ReactComponent };